import AuthorizationPageWrapper from './AuthorizationPageWrapper';

export default AuthorizationPageWrapper;
